import { render } from "./product-form.vue?vue&type=template&id=40d9a09e"
import script from "./product-form.vue?vue&type=script&lang=js"
export * from "./product-form.vue?vue&type=script&lang=js"

import "./product-form.vue?vue&type=style&index=0&id=40d9a09e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__